import { createSelector } from "../../../utils/createSelector.es.js";
const gridFocusStateSelector = (state) => state.focus;
const gridFocusCellSelector = createSelector(gridFocusStateSelector, (focusState) => focusState.cell);
const gridFocusColumnHeaderSelector = createSelector(gridFocusStateSelector, (focusState) => focusState.columnHeader);
createSelector(gridFocusStateSelector, (focusState) => focusState.columnHeaderFilter);
const unstable_gridFocusColumnGroupHeaderSelector = createSelector(gridFocusStateSelector, (focusState) => focusState.columnGroupHeader);
const gridTabIndexStateSelector = (state) => state.tabIndex;
const gridTabIndexCellSelector = createSelector(gridTabIndexStateSelector, (state) => state.cell);
const gridTabIndexColumnHeaderSelector = createSelector(gridTabIndexStateSelector, (state) => state.columnHeader);
createSelector(gridTabIndexStateSelector, (state) => state.columnHeaderFilter);
const unstable_gridTabIndexColumnGroupHeaderSelector = createSelector(gridTabIndexStateSelector, (state) => state.columnGroupHeader);
export {
  gridFocusCellSelector,
  gridFocusColumnHeaderSelector,
  gridFocusStateSelector,
  gridTabIndexCellSelector,
  gridTabIndexColumnHeaderSelector,
  gridTabIndexStateSelector,
  unstable_gridFocusColumnGroupHeaderSelector,
  unstable_gridTabIndexColumnGroupHeaderSelector
};
//# sourceMappingURL=gridFocusStateSelector.es.js.map
